export default __webpack_public_path__ + "static/media/AngusHappy.7b93c8d6.jpg";